<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Group" pageTitle="Group" />
            <GroupContant />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import GroupContant from '../Group/GroupContant'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'GroupPage',
    components: {
        MainHeader,
        PageTitle,
        GroupContant,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>